import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

import classes from './Drawer.module.scss'

const DrawerLink = ({ to, icon, external = false, children }) => (
  <Link
    to={to}
    target={external ? '_blank' : undefined}
    rel={external ? 'noopener noreferrer' : undefined}
    className={classNames(classes.pillLink, 'd-inline-flex align-items-center align-self-start')}
  >
    <i className={classNames('fa', icon)} aria-hidden='true' />
    {children}
  </Link>
)

DrawerLink.propTypes = {
  to: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  external: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

export default DrawerLink
